import { Modal } from 'almanac-ui/Modal'
import { ConfirmModal } from 'hooks/useConfirmModal'

interface Props extends ConfirmModal {
  title?: string
  msg?: string
}

export const ConfirmBackModal = ({
  onCancel,
  onConfirm,
  onPressOutside,
  title = 'Thinking of starting over?',
  msg = 'Going back will delete your current Brand Kit and start over. Are you sure?',
}: Props) => (
  <Modal.Root onPressOutside={onPressOutside}>
    <Modal.Header title={title} isConfirmation subHeader={msg} />
    <Modal.Footer isConfirmation>
      <Modal.FooterContent slot="left">
        <Modal.FooterButton onPress={onCancel} size="lg" variant="secondary">
          Cancel
        </Modal.FooterButton>
      </Modal.FooterContent>
      <Modal.FooterContent slot="right">
        <Modal.FooterButton onPress={onConfirm} size="lg" variant="primary">
          Confirm
        </Modal.FooterButton>
      </Modal.FooterContent>
    </Modal.Footer>
  </Modal.Root>
)
